module.exports = __webpack_public_path__ + "img/typeShare.0e23bc52.png";